// extracted by mini-css-extract-plugin
export default {"imageWrapper":"FG-z","hovered":"GG-z","hoverImage":"HG-z","mainImage":"IG-z","imageNoBackground":"JG-z","fullSizeImage":"KG-z"};